/**
 * Shallowly compares whether two arrays are different by looking
 * at the identities of the pairwise elements.
 */
export default function shallowArrayDiff(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  deps1: Array<any> | undefined,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  deps2: Array<any> | undefined
): boolean {
  return !(
    Array.isArray(deps1) &&
    Array.isArray(deps2) &&
    deps1.length === deps2.length &&
    deps1.every((dep, idx) => Object.is(dep, deps2[idx]))
  );
}
